export const WalletMenuIcon = ({ width = 32, height = 32 }) => (
  <svg
    width="24"
    height="22"
    viewBox="0 0 24 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0 18.3022C0 20.0384 1.41253 21.4509 3.14874 21.4509H20.8513C22.5875 21.4509 24 20.0384 24 18.3022V6.04636C24 4.64223 23.0551 3.39581 21.7022 3.01522L21.6173 2.99135L21.6105 2.90337C21.4843 1.27528 20.1058 0 18.4722 0H3.14874C1.41253 0 0 1.41253 0 3.14874V18.3022ZM22.7225 14.3238H17.7183C16.5592 14.3238 15.6163 13.3808 15.6163 12.2217C15.6163 11.0627 16.5592 10.1198 17.7183 10.1198H22.7225V14.3238ZM1.27749 3.14874C1.27749 2.11693 2.11693 1.27743 3.14874 1.27743H18.4722C19.3427 1.27743 20.111 1.89423 20.2991 2.74402L20.3331 2.89762H3.14874C2.55392 2.89762 1.97387 3.06562 1.47133 3.38349L1.27749 3.50608V3.14874ZM1.27749 6.04636C1.27749 5.01442 2.11693 4.1748 3.14874 4.1748H20.8513C21.8833 4.1748 22.7228 5.01436 22.7228 6.04636V8.84236H17.7183C15.8549 8.84236 14.3389 10.3583 14.3389 12.2217C14.3389 14.0852 15.8549 15.6012 17.7183 15.6012H22.7226V18.3023C22.7226 19.3341 21.8831 20.1736 20.8513 20.1736H3.14874C2.11693 20.1736 1.27749 19.3341 1.27749 18.3023V6.04636Z"
      fill="url(#paint0_linear_4430_55278)"
    />
    <path
      d="M18.0022 11.6099C17.6327 11.6099 17.3322 11.9104 17.3322 12.2798C17.3322 12.6495 17.6328 12.9502 18.0022 12.9502C18.3716 12.9502 18.6722 12.6494 18.6722 12.2798C18.6723 11.9104 18.3717 11.6099 18.0022 11.6099Z"
      fill="url(#paint1_linear_4430_55278)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_4430_55278"
        x1="0"
        y1="10.7262"
        x2="24.0013"
        y2="10.7262"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#000"/>
        <stop offset="1" stopColor="#000"/>
      </linearGradient>
      <linearGradient
        id="paint1_linear_4430_55278"
        x1="17.3322"
        y1="12.2801"
        x2="18.6723"
        y2="12.2801"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#000"/>
        <stop offset="1" stopColor="#000"/>
      </linearGradient>
    </defs>
  </svg>
);
